import React, { useState } from "react"; // Import useState hook to manage form data
import "./CaseForm.scss";

import { ReactComponent as SideBtnBlack } from "../../assets/svg/side-btn-black.svg";

const CaseForm = () => {
  // State variables to manage form data
  const [loading, setLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [formData, setFormData] = useState({
    firstname: "",
    lastname: "",
    email: "",
    company: "",
    message: "",
    privacyPolicy: false,
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const formDataToSend = { ...formData };
    delete formDataToSend.privacyPolicy;

    try {
      const response = await fetch(
        "https://backend-qqfw.onrender.com/api/send-email",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(formDataToSend),
        }
      );

      if (response.ok) {
        console.log("Email sent successfully");
        setSuccessMessage("Message sent successfully!");
        // Clear form data after successful submission if needed
        setFormData({
          firstname: "",
          lastname: "",
          email: "",
          company: "",
          message: "",
          privacyPolicy: false,
        });
      } else {
        console.error("Failed to send email");
      }
    } catch (error) {
      console.error("Error sending email:", error);
    } finally {
      setLoading(false);
      setSuccessMessage(" ");
    }
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    const val = type === "checkbox" ? checked : value;

    setFormData({
      ...formData,
      [name]: val,
    });
  };

  return (
    <section className="caseForm">
      <div className="caseForm__container--banner">
        <div className="caseForm__container--banner-text">
          <h2 className="first-h2">Need help with</h2>
          <h2>a project?</h2>
        </div>
      </div>
      <article className="caseForm__container container">
        <div className="caseForm__container--header">
          <div className="caseForm__container--header-title">
            <h3>Schedule a</h3>
            <h2> — meeting...</h2>
          </div>

          <p className="caseForm__container--header-subtitle">
            Ready to do big things? Fill out our form below
            <br /> and tell us about your vision.
          </p>
        </div>

        <form className="caseForm__container--form" onSubmit={handleSubmit}>
          <div className="form__wrapper">
            <div className="form__group--pair">
              <div className="form__group">
                <label>First name:*</label>
                <input
                  type="text"
                  name="firstname"
                  placeholder="Your first name"
                  className="form__input"
                  value={formData.firstname}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form__group">
                <label>Last name:*</label>
                <input
                  type="text"
                  name="lastname"
                  placeholder="Your last name"
                  className="form__input"
                  value={formData.lastname}
                  onChange={handleInputChange}
                  required
                />
              </div>
            </div>

            <div className="form__group--pair">
              <div className="form__group">
                <label>Email:*</label>
                <input
                  type="email"
                  name="email"
                  placeholder="Your email"
                  className="form__input"
                  value={formData.email}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="form__group">
                <label>Company Name:*</label>
                <input
                  type="text"
                  name="company"
                  placeholder="Your company name"
                  className="form__input"
                  value={formData.company}
                  onChange={handleInputChange}
                />
              </div>
            </div>

            <div className="form__group-textarea">
              <label>
                Tell Us About The Project (Scope, Timeline, Budget):*
              </label>
              <textarea
                rows={5}
                cols={50}
                name="message"
                placeholder="Tell us about your project"
                className="form__input"
                value={formData.message}
                onChange={handleInputChange}
              ></textarea>
            </div>
          </div>

          <div className="form__group--checkbox">
            <input
              className="radio-input"
              type="checkbox"
              name="privacyPolicy"
              id="privacy-policy"
              checked={formData.privacyPolicy}
              onChange={handleInputChange}
              required
            />
            <label className="radio-label" htmlFor="privacy-policy">
              <span className="radio-inner-circle"></span>Yes, sign me up!
            </label>
          </div>

          <button type="submit" className="form__group--submit">
            {loading ? (
              <div className="spinner"></div>
            ) : (
              <>
                {successMessage ? (
                  <span>{successMessage}</span>
                ) : (
                  <>
                    <div className="form__submit-btn">
                      <span>Send enquiry</span>
                    </div>
                    <SideBtnBlack />
                  </>
                )}
              </>
            )}
          </button>
        </form>
      </article>
    </section>
  );
};

export default CaseForm;
